import styled from 'styled-components/macro';

import { colors } from 'styles/colors';
import { device } from 'styles/device';
import { fontSizes, fontStyles } from 'styles/fonts';

export const Row = styled.div`
	background-color: ${colors.white};
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	display: flex;
	flex-shrink: 0;
	justify-content: ${({ title }) => (title ? 'space-between' : 'flex-end')};
	padding-bottom: 20px;
	width: 100%;
	z-index: 10;
	align-items: baseline;
`;

export const Title = styled.h1`
	${fontStyles[fontSizes.twenty]};
	color: ${colors.navy};
	font-weight: 800;
`;

export const CloseBtn = styled.button`
	background: transparent;
	border: none;
	cursor: pointer;
	outline: none;

	i {
		${fontStyles[fontSizes.eighteen]};
		color: ${colors.darkGrey};

		@media ${device.laptop} {
			${fontStyles[fontSizes.twenty]};
			color: ${colors.navy};
			font-weight: 800;
		}
	}
`;
